import Myaxios from  '../utils/myaxios'

export function importOrderPreList(data) {
    return Myaxios({
        url: '/manager/orderPre/importOrderPreList',
        data,
        method: 'post'
    })
}

export function getOrderPreList(data) {
    return Myaxios({
        url: '/manager/orderPre/getOrderPreList',
        data,
        method:'post'
    })
}

export function importOrderList(data) {
    return Myaxios({
        url: '/manager/order/exportSucOrder',
        data,
        method:'post'
    })
}

export function getOrderList(data) {
    return Myaxios({
        url: '/manager/order/getOrderList',
        data,
        method: 'post'
    })
}


export function addExpress(data) {
    return Myaxios({
        url: '/manager/order/sv-express',
        data,
        method: 'post'
    })
}